import { GraphType } from "../model/generic-graph";

export const updatedTopTenProductsMock = {
  title: 'Top 10 Products',
  type: GraphType.TOP_PRODUCTS,
  navigation: {
    type: 'GraphNavigation',
    nav: {
      month: [
        {
          title: 'LY',
          graph: {
            data: [
              {
                title: 'POTASH',
                value: {
                  value: 240,
                  positive: 1,
                },
                kmt: {
                  value: 1.548,
                  positive: -1,
                },
                price: {
                  value: 425,
                  positive: 1,
                },
                data: {
                  fields: [
                    {
                      kmt: {
                        sales: 1200,
                        salesCompare: 1600,
                        positive: -1,
                      },
                      dollarMT: {
                        sales: 1300,
                        salesCompare: 1300,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1200,
                        salesCompare: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        salesCompare: 1300,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1600,
                        salesCompare: 1200,
                        positive: 1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1000,
                        salesCompare: 1200,
                        positive: -1,
                      },
                      dollarMT: {
                        sales: 1400,
                        salesCompare: 1400,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1200,
                        salesCompare: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        salesCompare: 1300,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                    },
                  ],
                  graphs: {
                    kmt: {
                      columnType: null,
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    dollarMT: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    mDollar: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                  },
                },
              },
              {
                title: 'MAP',
                value: {
                  value: 220,
                  positive: 1,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: null,
              },
              {
                title: 'GPK',
                value: {
                  value: 220,
                  positive: -1,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: null,
              },
              {
                title: 'GPAC 4D',
                value: {
                  value: 210,
                  positive: 1,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: null,
              },
              {
                title: 'GTSP',
                value: {
                  value: 200,
                  positive: 0,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: null,
              },
            ],
          },
        },
        {
          title: 'C',
          graph: {
            data: [
              {
                title: 'POTASH',
                value: {
                  value: 233,
                  positive: 1,
                },
                kmt: {
                  value: 1.548,
                  positive: -1,
                },
                price: {
                  value: 425,
                  positive: 1,
                },
                data: {
                  fields: [
                    {
                      kmt: {
                        sales: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                    {
                      kmt: {
                        sales: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1100,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                    {
                      kmt: {
                        sales: 1500,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                    {
                      kmt: {
                        sales: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1700,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                  ],
                  graphs: {
                    kmt: {
                      columnType: null,
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    dollarMT: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    mDollar: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                  },
                },
              },
              {
                title: 'GTSP',
                value: {
                  value: 230,
                  positive: 1,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: {
                  fields: [
                    {
                      kmt: {
                        sales: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                    {
                      kmt: {
                        sales: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1100,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                    {
                      kmt: {
                        sales: 1500,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                    {
                      kmt: {
                        sales: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1700,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                  ],
                  graphs: {
                    kmt: {
                      columnType: null,
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    dollarMT: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    mDollar: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                  },
                },
              },
              {
                title: 'GPK',
                value: {
                  value: 220,
                  positive: -1,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: null,
              },
              {
                title: 'GPAC 4D',
                value: {
                  value: 210,
                  positive: 1,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: null,
              },
              {
                title: 'MAP',
                value: {
                  value: 200,
                  positive: 0,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: null,
              },
            ],
          },
        },
      ],
      qtd: [
        {
          title: 'LY',
          graph: {
            data: [
              {
                title: 'POTASH',
                value: {
                  value: 233,
                  positive: 1,
                },
                kmt: {
                  value: 1.548,
                  positive: -1,
                },
                price: {
                  value: 425,
                  positive: 1,
                },
                data: {
                  fields: [
                    {
                      kmt: {
                        sales: 1200,
                        salesCompare: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        salesCompare: 1200,
                        positive: 1,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1100,
                        salesCompare: 1100,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1700,
                        salesCompare: 1700,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1300,
                        salesCompare: 1500,
                        positive: -1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1100,
                        salesCompare: 1200,
                        positive: -1,
                      },
                      dollarMT: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1500,
                        positive: -1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1100,
                        salesCompare: 1200,
                        positive: -1,
                      },
                      dollarMT: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1500,
                        positive: -1,
                      },
                    },
                  ],
                  graphs: {
                    kmt: {
                      columnType: null,
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    dollarMT: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 72,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    mDollar: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 45,
                            percent: -12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                  },
                },
              },
              {
                title: 'test',
                value: {
                  value: 230,
                  positive: 1,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: {
                  fields: [
                    {
                      kmt: {
                        sales: 1200,
                        salesCompare: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        salesCompare: 1200,
                        positive: 1,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1100,
                        salesCompare: 1100,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1700,
                        salesCompare: 1700,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1300,
                        salesCompare: 1500,
                        positive: -1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1100,
                        salesCompare: 1200,
                        positive: -1,
                      },
                      dollarMT: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1500,
                        positive: -1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1100,
                        salesCompare: 1200,
                        positive: -1,
                      },
                      dollarMT: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1500,
                        positive: -1,
                      },
                    },
                  ],
                  graphs: {
                    kmt: {
                      columnType: null,
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    dollarMT: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 72,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    mDollar: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 45,
                            percent: -12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                  },
                },
              },
              {
                title: 'GPK',
                value: {
                  value: 220,
                  positive: -1,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: null,
              },
              {
                title: 'GPAC 4D',
                value: {
                  value: 210,
                  positive: 1,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: {
                  fields: [
                    {
                      kmt: {
                        sales: 1200,
                        salesCompare: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        salesCompare: 1200,
                        positive: 1,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1100,
                        salesCompare: 1100,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1700,
                        salesCompare: 1700,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1300,
                        salesCompare: 1500,
                        positive: -1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1100,
                        salesCompare: 1200,
                        positive: -1,
                      },
                      dollarMT: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1500,
                        positive: -1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1100,
                        salesCompare: 1200,
                        positive: -1,
                      },
                      dollarMT: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1500,
                        positive: -1,
                      },
                    },
                  ],
                  graphs: {
                    kmt: {
                      columnType: null,
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    dollarMT: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 72,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    mDollar: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 45,
                            percent: -12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                  },
                },
              },
              {
                title: 'GTSP',
                value: {
                  value: 200,
                  positive: 0,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: {
                  fields: [
                    {
                      kmt: {
                        sales: 1200,
                        salesCompare: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        salesCompare: 1200,
                        positive: 1,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1100,
                        salesCompare: 1100,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1700,
                        salesCompare: 1700,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1300,
                        salesCompare: 1500,
                        positive: -1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1100,
                        salesCompare: 1200,
                        positive: -1,
                      },
                      dollarMT: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1500,
                        positive: -1,
                      },
                    },
                    {
                      kmt: {
                        sales: 1100,
                        salesCompare: 1200,
                        positive: -1,
                      },
                      dollarMT: {
                        sales: 1400,
                        salesCompare: 1200,
                        positive: 1,
                      },
                      mDollar: {
                        sales: 1400,
                        salesCompare: 1500,
                        positive: -1,
                      },
                    },
                  ],
                  graphs: {
                    kmt: {
                      columnType: null,
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    dollarMT: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 72,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    mDollar: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 45,
                            percent: -12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          compare: {
                            value: 50,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          compare: {
                            value: 0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                  },
                },
              },
            ],
          },
        },
        {
          title: 'C',
          graph: {
            data: [
              {
                title: 'POTASH',
                value: {
                  value: 233,
                  positive: 1,
                },
                kmt: {
                  value: 1.548,
                  positive: -1,
                },
                price: {
                  value: 425,
                  positive: 1,
                },
                data: {
                  fields: [
                    {
                      kmt: {
                        sales: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                    {
                      kmt: {
                        sales: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1100,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                    {
                      kmt: {
                        sales: 1500,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                    {
                      kmt: {
                        sales: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1700,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                  ],
                  graphs: {
                    kmt: {
                      columnType: null,
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    dollarMT: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    mDollar: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                  },
                },
              },
              {
                title: 'GTSP',
                value: {
                  value: 230,
                  positive: 1,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: {
                  fields: [
                    {
                      kmt: {
                        sales: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                    {
                      kmt: {
                        sales: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1100,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                    {
                      kmt: {
                        sales: 1500,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1300,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                    {
                      kmt: {
                        sales: 1200,
                        positive: 0,
                      },
                      dollarMT: {
                        sales: 1700,
                        positive: 0,
                      },
                      mDollar: {
                        sales: 1400,
                        positive: 0,
                      },
                    },
                  ],
                  graphs: {
                    kmt: {
                      columnType: null,
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    dollarMT: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                    mDollar: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Q1',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q2',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                        },
                        {
                          colName: 'Q3',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 62,
                            percent: 12,
                          },
                          isPreliminary: false,
                          isDefault: true,
                          isFuture: false,
                        },
                        {
                          colName: 'Q4',
                          colGroupName: null,
                          partial: null,
                          current: {
                            value: 0,
                            percent: 0,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: true,
                        },
                      ],
                    },
                  },
                },
              },
              {
                title: 'GPK',
                value: {
                  value: 220,
                  positive: -1,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: null,
              },
              {
                title: 'GPAC 4D',
                value: {
                  value: 210,
                  positive: 1,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: null,
              },
              {
                title: 'MAP',
                value: {
                  value: 200,
                  positive: 0,
                },
                kmt: {
                  value: 0,
                  positive: 1,
                },
                price: {
                  value: 0,
                  positive: 1,
                },
                data: null,
              },
            ],
          },
        },
      ],
    },
  },
};